import React, { useState, useEffect } from 'react';
import { Footer } from './components/Footer/Footer';
import { Header } from './components/Header/Header';
import { Main } from './components/Main/Main';
import { ICard } from './interfaces/card';
import { IFilter } from './interfaces/filter';
import { filterDefault } from './data/filterDefault';

export function App() {
    const MAX_COUNT_IN_CART = 20;
    const START_COUNT_IN_CART = 0;
    const [countInCart,setCountInCart] = useState(START_COUNT_IN_CART);
    const [loaded, setLoaded] = useState(false);
    const [cards, setCards] = useState<ICard[]>([]);
    const [filteredCards, setFilteredCards] = useState<ICard[]>([]);
    const [filter, setFilter] = useState<IFilter>(JSON.parse(JSON.stringify(filterDefault)));

    const addToCart = (card: HTMLInputElement) => {
        let newValue = countInCart + ( card.checked ? 1 : - 1);
        if (newValue > MAX_COUNT_IN_CART) {
            newValue -= 1;
            card.checked = false;
            alert(`Sorry. Cart is full`);
        }
        setCountInCart(newValue);
    }

    const filterCards = () => {
        const shouldShowDefaultCategory = Object.values(filter.category).every((item) => item === false);
        const categoryShow = shouldShowDefaultCategory ? Object.keys(filter.category): Object.entries(filter.category).filter(item => item[1]).map(([key,]) => key);
        const shouldShowDefaultRate = Object.values(filter.rate).every((item) => item === false);
        const rateShow = shouldShowDefaultRate ? Object.keys(filter.rate): Object.entries(filter.rate).filter(item => item[1]).map(([key,]) => key);
        const newValue = cards
            .map(card => {
                card.hide = false;
                const isItemInsearch = card.title.toLowerCase().includes(filter.search.toLowerCase());
                const isItemCategoryEnabled = categoryShow.includes(card.category);
                const isItemRatingMatches = rateShow.includes(`${Math.floor(card.rating.rate)}`);
                const isItemPriseInRange = (card.price >= filter.price.min && card.price <= filter.price.max);
                const isItemCountsInRange = (card.rating.count >= filter.counts.min && card.rating.count <= filter.counts.max);
                if(!isItemInsearch || !isItemCategoryEnabled || !isItemRatingMatches || !isItemPriseInRange || !isItemCountsInRange) {
                    card.hide = true;
                }
                return card;
            })
            .sort((a,b) => {
                if (!filter.sort.by || ! filter.sort.order) return 0;
                let valueA: string | number;
                let valueB: string | number;
                switch (filter.sort.by) {
                case 'title': {
                    valueA = a.title;
                    valueB = b.title;
                    break;
                }
                case 'price': {
                    valueA = a.price;
                    valueB = b.price;
                    break;
                }
                case 'rate': {
                    valueA = a.rating.rate;
                    valueB = b.rating.rate;
                    break;
                }
                }
                switch (filter.sort.order) {
                case 'asc': {
                    return (valueA < valueB)? -1 : (valueA > valueB) ? 1 : 0;
                }
                case 'desc': {
                    return (valueA > valueB)? -1 : (valueA < valueB) ? 1 : 0;
                }
                }
            });
        setFilteredCards([...newValue]);
    }

    const changeFilter = (value: IFilter) => {
        setFilter(value);
        filterCards();
    }

    useEffect(()=>{
        fetchCards();
    },[]);

    const fetchCards = async () => {
        const resp = await fetch('https://fakestoreapi.com/products');
        if (resp.ok) {
            const respData = await resp.json();
            loadCards(respData.map((item:Record<string,unknown>) => Object.assign(item,{hide: false,cheked: false})));
            setLoaded(true);
        } else {
            alert('Sorry. The product list is not available. Reload the page or come back later.');
        }
    }

    const loadCards = (respData: ICard[]) => {
        const newRespData = [...respData.map((item: ICard) => ({
            id: item.id + respData.length,
            category: item.category,
            description: item.description,
            image: item.image,
            price: item.price,
            rating: {
                count: item.rating.count,
                rate: item.rating.rate
            },
            title: item.title,
            hide: item.hide,
            checked: item.checked
        })),...respData.sort((a: ICard, b: ICard) => b.rating.rate - a.rating.rate)];
        setCards([...newRespData]);
        setFilteredCards([...newRespData]);
    }

    return (
        <div className="App">
            <Header countInCart = {countInCart} isLoaded = {loaded} />
            <Main addingToCartCallback = {addToCart}
                filter = {filter}
                filterCallback = {changeFilter}
                cards = {filteredCards}
                loaded = {loaded}
            />
            <Footer />
        </div>
    );
}